(async section_name => {
    let wait = 200;
    while (!window.Swiper && wait--) await new Promise(r => setTimeout(r, 150));
    new Swiper(`.${section_name}_swiper`, {
        loop: false,
        slidesPerView: 3,
        spaceBetween: 24,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 20
            },
            400: {
                slidesPerView: 1.4,
                spaceBetween: 20
            },
            600: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            768: {
                slidesPerView: 3
            }
        },
        pagination: {
            el: `.${section_name}-pagination`,
            clickable: true,
        }
    });
})("acc-st-landingpage-102_07").catch(console.info);
